module.exports = __webpack_public_path__ + "assets/img/btn-detail-f23f2953.png";